import React, { useState } from "react";
import { Link } from 'react-router-dom';
import admin from "../../images/banner/admin.png";
import "bootstrap-icons/font/bootstrap-icons.css";
import axios from 'axios';
import AuthUser from '../AuthUser';

const servicesStyle = {
    backgroundImage: `url(${admin})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundColor :'#e6f4ff',
    width :'100%',
    height: '33vh',
};

const Createhconsultant = () => {

    const {usertype,logout,getUser} = AuthUser();
    let userdetails = getUser();
    
    const [formData, setFormData] = useState({
		fullname: '',
        currentlocation: '',
        jobtitle: '',
        visastatus: '',
        relocation: '',
        jobtitle: '',
        years:'0',
        months:'0',
        admid: userdetails.admid,
    });

    const invalidfeedback = {
        display: 'block',
        width: '100%',
        fontSize: '12px',
        color : '#dc3545',
        marginLeft : '0px'
    };

    const [errors, setErrors] = useState({});
    const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    
    const handleSubmit = async (e) => {
        e.preventDefault();
		//console.log(formData);
        try {
            const response = await axios.post('https://api.transnational.ai/api/createhconsultant', formData,);
            setErrors({});
			setSuccess(response.data.message);
            //console.log(response.data);
        } catch (error) {
            //console.log(error.response.status)
            if (error.response && error.response.status === 422) {
                setErrors(error.response.data.errors);
            }else if (error.response && error.response.status === 401) {
                setError(error.response.data.errormessage);
            } else {
                console.error('Error submitting form:', error);
                
            }
        }
    };

    return (
        <section style={{ backgroundColor:'#f4f4f4' }}>
            <section id="bannerSection" style={servicesStyle}>
                <div className="container">
                    <h1 id="HR"></h1>
                </div>
            </section>
            <div className="media-body" style={{ minHeight:'500px', padding:'10px'}}>
		        <div className="container">
			        <div className="col-12" style={{ }}>
				        <div className="well well-small" style={{ textAlign:'left', backgroundColor:'#fff' }}>
					        <ul className="media-list">
						        <li className="media well well-small" style={{ marginTop:'10px',marginLeft:'-15px',marginRight:'15px',marginBottom:'-5px'}}>
                                    <section className="breadcrumb" style={{ marginLeft:'5px', marginTop:'5px',marginRight:'5px'}}>
                                        <div  className="col-12 breadcrumbs" >
                                            <a href="/admin/Dashboard">Home</a> <i class="bi bi-chevron-double-right"></i> <a href="/admin/Hotlistdashboard">Hotlist Dashboard</a> <i class="bi bi-chevron-double-right"></i> <span>Create Hotlist consultant</span>
                                        </div>
                                    </section>
                            
                                    <div className="container" style={{ minHeight:'400px'}}>
                                        { success !== '' && <div className="alert alert-success">{success}</div> }
                                        { error !== '' && <div className="alert alert-danger">{error}</div> }
                                        <form id="changepassword" onSubmit={handleSubmit}>
									    <table width={940} border={0} align="center" cellPadding={10} cellSpacing={10}>
										<tr>
											<td width="250"><span >Name *</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="fullname" maxLength={40} className="ui_text" value={formData.fullname} onChange={handleChange} /></td>
                                            <td>{errors.fullname && <span style={invalidfeedback}>{errors.fullname[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Job Title</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="jobtitle" maxLength={40} className="ui_text" value={formData.jobtitle} onChange={handleChange} /></td>
                                            <td>{errors.jobtitle && <span style={invalidfeedback}>{errors.jobtitle[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Current Location *</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="currentlocation" maxLength={40} className="ui_text" value={formData.currentlocation} onChange={handleChange} /></td>
                                            <td>{errors.currentlocation && <span style={invalidfeedback}>{errors.currentlocation[0]}</span>}</td>
										</tr>
                                        <tr>
											<td width="250"><span >Relocation</span></td>
											<td width="10">:</td>
											<td width="250"><input type="text" name="relocation" maxLength={40} className="ui_text" value={formData.relocation} onChange={handleChange} /></td>
                                            <td>{errors.relocation && <span style={invalidfeedback}>{errors.relocation[0]}</span>}</td>
										</tr>
										<tr>
											<td><span >Visa Status</span></td>
											<td>:</td>
											<td><input type="text" name="visastatus" maxLength={50} className="ui_text" value={formData.visastatus} onChange={handleChange} /></td>
                                            <td>{errors.visastatus && <span style={invalidfeedback}>{errors.visastatus[0]}</span>}</td>
										</tr>
										
										<tr>
											<td><span>Experience</span></td>
											<td>:</td>
											<td><table cellpadding="0" cellspacing="0" border="0">
                                              <tr>
                                                <td valign="top">
                                                    <select size="1" style={{ width:'80px',height:'30px'}} name="years" onChange={handleChange}>
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                    <option value="13">13</option>
                                                    <option value="14">14</option>
                                                    <option value="15">15</option>
                                                    <option value="16">16</option>
                                                    <option value="17">17</option>
                                                    <option value="18">18</option>
                                                    <option value="19">19</option>
                                                    <option value="20">20</option>
                                                    <option value="21">21</option>
                                                    <option value="22">22</option>
                                                    <option value="23">23</option>
                                                    <option value="24">24</option>
                                                    <option value="25">25</option>
                                                    <option value="26">26</option>
                                                    <option value="27">27</option>
                                                    <option value="28">28</option>
                                                    <option value="29">29</option>
                                                    <option value="30">30</option>
                                                    <option value="30+">30+</option>
                                                    </select></td>
                                                <td><span className="label_normal">Years&nbsp;&nbsp;</span></td>
                                                <td valign="top">
                                                    <select size="1" style={{ width:'80px',height:'30px'}} name="months" onChange={handleChange}>
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    </select></td>
                                                <td><span> Months</span></td>
                                              </tr>
                                            </table></td>
                                            <td></td>
										</tr>
										<tr>
											<td>&nbsp;</td>
											<td></td>
											<td height="50"><input name="changepassword" type="submit" value="Submit" className="btn btn-primary btn-block" style={{ width:'220px'}} /></td>
                                            <td></td>
										</tr>
									    </table>
								        </form> 
                                        <br/>
							        </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>       
        </section>
    );
}

export default Createhconsultant;